<template>
  <p class="wl-dynamic-freshness">
    Data checked for accuracy: {{ formattedDate }}
  </p>
</template>

<script>
export default {
  name: 'wl-dynamic-freshness',
  computed: {
    formattedDate() {
      const now = new Date();
      // Format date to be the third of the month and two months ago.
      const date = new Date(now.getFullYear(), now.getMonth() - 2, 3);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
  }
};
</script>
